export const roleIs = (role: string, userRole: string) => {
  return role.toLowerCase() === userRole.toLowerCase()
}
